import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const GaugeChart1Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'feedback',
    items: [
      'feedback-count',
      'feedback-nps',
      'feedback-csat',
      'feedback-ces',
      'feedback-sentiment-score',
      'feedback-weighted-score',
      'feedback-chat-score',
    ],
  },
  {
    type: 'kpi',
    items: ['csat-kpi', 'nps-kpi'],
  },
];
